export const companyRouteRoot = '/company'

export const companyRoute = {
  generalInformation: '/general-information',
}
